import React from "react"

import ReactTable from "react-table"

import { APIPost, APIGet } from "services/APIRequest"
import ConfigHost from "services/ConfigHost"

import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import { ErrorsCallback, SuccessCallback, WarningCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"

import { ISOToDateFormat } from "helpers/ConvertDate"
import { thaiBath } from "helpers/ConvertFormat"
import Datetime from "react-datetime";
import { replaceNumberQuestion } from "helpers/ConvertString"

import * as Alert from "alertService"

import wordingQuestion from "configs/wordingQuestion.jsx"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

// @material-ui/icons
import ViewListIcon from '@material-ui/icons/ViewList';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
import SearchIcon from "@material-ui/icons/Search";

// @material-ui/Dialog 
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import CustomInput from "components/CustomInput/CustomInput.jsx"
import Button from "components/CustomButtons/Button.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import Select from "components/CustomSelects/Select.jsx"
import Autocomplete from "components/Autocomplete/Select.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
import FormLabel from "@material-ui/core/FormLabel"
import { colors } from "@material-ui/core"
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "15px"
  }
}

var userCode = Auth.getUserData()

class ReportQuarterPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dataDealer: [],
      currentLanguage: [],
      currentBranchName: [],
      currentYearList: null,
      yearList: [
        {
          label: "ตั้งแต่ เดือน 7 ปี 2020 ถึง เดือน 6 ปี 2021",
          value: "2020",
        },
        {
          label: "ตั้งแต่ เดือน 7 ปี 2021 ถึง เดือน 6 ปี 2022",
          value: "2021",
        }
      ],
    }
  }
  componentDidMount() {
    this.loadDealerDataList(() => {
    })
  }

  loadDealerDataList = (callback) => {
    APIPost(UrlServer.URL_POST_GET_DEALER, { dealer_code: userCode.dealer_code }, ({ datas }) => {
      var newConvertDatas = arrayObject(datas, [
        {
          oldKey: "dealer_code",
          newKey: "value"
        },
        {
          oldKey: "branch_name",
          newKey: "label"
        }
      ]
      )
      this.setState({
        dataDealer: newConvertDatas
      }, () => {
        callback()
      });
    })
  }
  handleDialogClose = () => {
    this.setState({ statusDialogOpen: false })
  }

  handleDialogOpen = (index) => {
    this.setState({
      currentData: this.state.rawData[index],
      currentUserName: this.state.rawData[index].first_name + " " + this.state.rawData[index].last_name
    }, () => {
      this.setState({ statusDialogOpen: true })
    })
  }


  handleDateTimeChange = (name, date) => {
    const dateF = new Date(date).toISOString()
    this.setState({
      [name]: dateF
    })
  }
  handleChange = (name, val) => {

    this.setState({
      [name]: val
    })
  }
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }
  loopDataQuetions = (datas) => {
    if (!datas || !datas.question_id || !datas.question_id.answers_obj) return
    var data = JSON.parse(datas.question_id.answers_obj)
    if (!data.sc1) return
    data = data.sc1
    var res = []
    var sort_data = {}
    for (let index = 1; index <= 26; index++) {
      if (data["q" + index] != undefined) {
        sort_data["q" + index] = data["q" + index]
      }
    }
    data = sort_data
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const c_data = data[key];
        var answer = ""
        switch (data[key].type) {
          case "Radio":
          case "QRadio":
            answer = data[key].name
            if (data[key].value == 6)
              answer = data[key].comment
            break;
          case "QButtonPoint":
          case "QSlider":
          case "Input":
            answer = data[key].value
            break;
          default:
            break;
        }
        res.push(
          <div>
            <div className="quetions_title">{replaceNumberQuestion(key)}.{this.setBranchName(key, datas, wordingQuestion[key].dataQuestion.th.question)}</div>
            <div className={(answer != "") ? "has_answer" : "not_answer"}>ตอบ : {answer} </div>
            <div className="hr-q"></div>
          </div>
        )
      }
    }
    return res
  }

  handleChangeAutoCompleteNormally = name => value => {
    this.setState({
      [name]: value,
    }, () => {

    })
  }
  handleChangeAutoComplete = name => value => {
    this.setState({
      [name]: value,
    }, () => {
      if (name == "currentDataListChannel") {
        if (
          (this.state.currentDataListChannel[0] && this.state.currentDataListChannel[0].value && this.state.currentDataListChannel[0].value == "All") ||
          (this.state.currentDataListChannel[1] && this.state.currentDataListChannel[1].value && this.state.currentDataListChannel[1].value == "All") ||
          (this.state.currentDataListChannel[2] && this.state.currentDataListChannel[2].value && this.state.currentDataListChannel[2].value == "All")
        ) {
          this.setState({
            currentStatusOS: [],
            currentStatusTS: [],
          })
        }

        if (
          !(
            (this.state.currentDataListChannel[0] && this.state.currentDataListChannel[0].value && this.state.currentDataListChannel[0].value == "OS") ||
            (this.state.currentDataListChannel[1] && this.state.currentDataListChannel[1].value && this.state.currentDataListChannel[1].value == "OS") ||
            (this.state.currentDataListChannel[2] && this.state.currentDataListChannel[2].value && this.state.currentDataListChannel[2].value == "OS")
          )
        ) {
          this.setState({
            currentStatusOS: []
          })
        }

        if (
          !(
            (this.state.currentDataListChannel[0] && this.state.currentDataListChannel[0].value && this.state.currentDataListChannel[0].value == "TS") ||
            (this.state.currentDataListChannel[1] && this.state.currentDataListChannel[1].value && this.state.currentDataListChannel[1].value == "TS") ||
            (this.state.currentDataListChannel[2] && this.state.currentDataListChannel[2].value && this.state.currentDataListChannel[2].value == "TS")
          )
        ) {
          this.setState({
            currentStatusTS: []
          })
        }
      }
    });
  };
  setBranchName = (key, data, txt) => {
    if (key == "q1") {
      return txt.replace("<?{branch_name}?>", data.branch_name)
    } else {
      return txt
    }
  }
  handleDownloadExcelFile = () => {
    if (!this.state.currentYearList) {
      WarningCallback("โปรดเลือกข้อมูลในรอบปีที่ต้องการ");
      return
    }
    if (!this.state.currentBranchName.value) {
      if (userCode.user_type_code != 4) {
        WarningCallback("โปรดเลือกเลือกสาขา");
        return
      }
    }
    if (!this.state.currentLanguage.value) {
      WarningCallback("โปรดเลือกเลือกภาษา");
      return
    }
    var dataForSend = {
      dealer_code: userCode.user_type_code == 4 ? userCode.dealer_code : this.state.currentBranchName.value,
      language: this.state.currentLanguage.value,
      data_year: this.state.currentYearList.value,
    }
    Alert.Loading(true)
    APIGet(UrlServer.URL_GET_GENERATEREPORTS_RUN_CLEAN_RAW_REPORT_GENERATE_AND_GET_DATA_REPORT + dataForSend.dealer_code + "/" + dataForSend.language + "/" + dataForSend.data_year, ({ datas }) => {
      var _res = JSON.parse(datas)
      Alert.LoadingClose()
      const response = {
        file: _res.pathFile,
      };
      // document.location = response.file
      window.open(response.file, '_blank');
    })
  }
  handleDownloadExcelFileAll = () => {
    if (!this.state.currentLanguage || !this.state.currentLanguage.value) {
      WarningCallback("โปรดเลือกเลือกภาษา");
      return
    }

    var loop_count = 0
    const loop_max = this.state.dataDealer.length
    const loadCheckLoop = () => {
      if (loop_count >= loop_max) {

      } else {
        loadReport()
      }
    }
    const loadReport = () => {
      var dataForSend = {
        dealer_code: this.state.dataDealer[loop_count].value,
        language: this.state.currentLanguage.value,
        data_year: this.state.currentYearList.value,
      }
      Alert.Loading(true, "อันที่ " + (loop_count + 1) + "/" + loop_max + " : สาขา " + this.state.dataDealer[loop_count].label + " , " + this.state.dataDealer[loop_count].value)
      APIGet(UrlServer.URL_GET_GENERATEREPORTS_RUN_CLEAN_RAW_REPORT_GENERATE_AND_GET_DATA_REPORT + dataForSend.dealer_code + "/" + dataForSend.language+ "/" + dataForSend.data_year, ({ datas }) => {
        var _res = JSON.parse(datas)
        Alert.LoadingClose()
        loop_count++
        loadCheckLoop()
        const response = {
          file: _res.pathFile,
        };
        document.location = response.file
      })
    }
    loadCheckLoop()
  }
  render() {
    const { classes } = this.props
    const userData = Auth.getUserData()
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <ViewListIcon />
                </CardIcon>
                ออกรายงาน
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer >
                    <GridItem xs={12} sm={12} >
                      <GridContainer>
                        <GridItem xs={12} className={"autocomplete-space"}>
                          <Autocomplete
                            handleChange={this.handleChangeAutoComplete}
                            value={this.state.currentYearList}
                            dataList={this.state.yearList}
                            id="currentYearList"
                            label="เลือกข้อมูลในรอบปี"
                          // multi
                          />
                        </GridItem>
                        <GridItem xs={12} className={"autocomplete-space"}>
                          <GridContainer >
                            {
                              userCode.user_type_code != 4 ?
                                <GridItem xs={6}>
                                  {
                                    (this.state.dataDealer.length > 0) ?
                                      <Autocomplete
                                        handleChange={this.handleChangeAutoCompleteNormally}
                                        value={this.state.currentBranchName}
                                        dataList={this.state.dataDealer}
                                        // multi
                                        id="currentBranchName"
                                        label="เลือกสาขา"
                                      />
                                      : ""
                                  }
                                </GridItem>
                                : ""
                            }
                            <GridItem xs={userCode.user_type_code != 4 ? 6 : 12}>
                              <Autocomplete
                                handleChange={this.handleChangeAutoComplete}
                                value={this.state.currentLanguage}
                                dataList={[
                                  {
                                    label: "TH",
                                    value: "TH",
                                  },
                                  {
                                    label: "EN",
                                    value: "EN",
                                  },
                                ]}
                                id="currentLanguage"
                                label="เลือกภาษา"
                              />
                            </GridItem>
                          </GridContainer>
                        </GridItem>
                      </GridContainer>
                      <GridContainer className={classes.mt4}>
                        <GridItem xs={12} sm={6}>
                          {
                            <Button
                              fullWidth
                              round
                              color="info"
                              onClick={this.handleDownloadExcelFile}
                            >
                              <CloudDownloadIcon className={classes.icons} />
                              ดาวน์โหลด Report Excel
                            </Button>
                          }

                        </GridItem>
                        {
                          (userData.user_type_code == 0 || userData.user_type_code == 1) ?
                            <GridItem xs={12} sm={6}>
                              {
                                <Button
                                  fullWidth
                                  round
                                  color="danger"
                                  onClick={this.handleDownloadExcelFileAll}
                                >
                                  <CloudDownloadIcon className={classes.icons} />
                                  ดาวน์โหลด Report Excel ( ทุกสาขา )
                                </Button>
                              }
                            </GridItem>
                            : ""
                        }

                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

export default withStyles(styles)(ReportQuarterPage)
